import Tracking from './tracking';

export default new class Embed {
	/**
	 * @type {NodeList} $iframe
	 */
	#$$embeds;

    init() {
        this.initDOM();
        this.initEl();
        this.bindEvents();
    }

	initDOM() {
		this.#$$embeds = document.body.querySelectorAll( '[data-tracking="embed"]' )

        console.log("this.#$$embeds", this.#$$embeds);

        if ( !this.#$$embeds.length ) return

        this.#$$embeds.forEach(($item) => {
            console.log('$item', $item)
            $item.$iframe = $item.querySelector('iframe');
            $item.$iframe.inert = true;
            $item.$consent = $item.querySelector('.flx_embed--consent');
            $item.$btn = $item.querySelector('.accept-cookies');
            $item.$btn.addEventListener('click', this.#acceptCookies.bind(this));
        })
	}

	initEl() {
		// if embed cookie are accepted
		if (Tracking.getCookieAcceptance('embed')) {
			this.#activateEmbed(); // activate the embed
		}
	}

	bindEvents() {
		document.body.addEventListener('GRAHOU_tracking_consent_embed', this.#activateEmbed.bind(this));
		Tracking.on(Tracking.E.REFUSE_TRACKING, this.#disableEmbed.bind(this), this);
	}

	/**
	 * Accept cookies for embed
	 * @private
	 * @return {void}
	 */
	#acceptCookies() {
		Tracking.addTrackingService('embed'); // add tracking service
	}

	/**
	 * Activate embed
	 * @private
	 * @return {void}
	 */
	#activateEmbed() {
        this.#$$embeds.forEach(($item) => {
            const src = $item.$iframe.getAttribute('data-src');
            $item.$iframe.setAttribute('src', src);
            $item.classList.remove('no_consent');
            $item.$iframe.inert = false
        })

	}

	/**
	 * Disable embed
	 * @private
	 * @return {void}
	 */
	#disableEmbed() {
        this.#$$embeds.forEach(($item) => {
            $item.$iframe.removeAttribute('src');
            $item.classList.add('no_consent');
            $item.$iframe.inert = true
        })

	}
}
